import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import withRouter from '../../lib/withRouter'
import actions from '../../actions/Networks'
import connectIndex from '../../lib/connectIndex'
import BrandReportsDisplay from '../common/BrandReportsDisplay'

export class NetworkIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    flashMessages: PropTypes.array.isRequired,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    searchColumns: ['name', 'vericred_network_id', 'carrier_brand']
  }

  static columns = [
    {
      key: 'carrier_brands',
      label: 'Carrier Brands',
      display: BrandReportsDisplay,
      sortable: false
    },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'vericred_network_id', label: 'Vericred Network ID', sortable: false },
    { key: 'active_from', label: 'Active From', sortable: false },
    { key: 'active_until', label: 'Active Until', sortable: false }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/networks"
          name="Network"
          pagination={this.props.pagination}
          columns={NetworkIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          searchPlaceholder="Search by Name, Vericred Network ID or Carrier Brand Name"
          searchColumns={this.props.searchColumns}
          filterable
          includeNewRecordLink={false}
          includeBulkActionLink={false}
          actions={[]}
          history={this.props.history}
        />
      </div>
    )
  }
}

const filters = []

export default connectIndex(withRouter(NetworkIndex), 'networks', actions, filters)
